import { SecondaryCategory } from '@webapp/core/entities/internal/SecondaryCategory'
import { type RequestableCategoryRepository } from '@webapp/modules/expense/data-access/repositories/RequestableCategoryRepository'

interface ExecuteParams {
  locationId: number
  departmentId: number
}

interface ResolveReviseFormDefaultsResult {
  defaultDepartment: Nullable<SecondaryCategory>
}

interface Dependency {
  requestableCategoryRepository: RequestableCategoryRepository
}

export class ResolveReviseFormDefaultsUseCase {
  constructor(private readonly deps: Dependency) {}

  execute = async ({
    locationId,
    departmentId,
  }: ExecuteParams): Promise<ResolveReviseFormDefaultsResult> => {
    const departmentConstructors =
      await this.deps.requestableCategoryRepository.listRequestableDepartments(
        locationId
      )

    if (departmentConstructors.length === 0) {
      return { defaultDepartment: null }
    }

    const matched = departmentConstructors.find(
      (dept) => dept.id === departmentId
    )

    const defaultDepartment = matched
      ? new SecondaryCategory(matched)
      : new SecondaryCategory(departmentConstructors[0])

    return { defaultDepartment }
  }
}
